import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PDFDocument } from 'pdf-lib';
import { FileHelper } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-sample-credit-report-order-rw',
  templateUrl: './page-sample-credit-report-order-rw.component.html',
  styleUrls: ['./page-sample-credit-report-order-rw.component.css', '../module-page-rw/module-page-rw.component.css']
})
export class PageSampleCreditReportOrderRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  content = {
    downloaded: false,
    validate:   false,
  };

  sampleCreditReportOrder: string = "../../../../../assets/sampleCreditReportOrder.pdf";
  orderHandout!: PDFDocument;

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  async ngOnInit(): Promise<void> {
    const orderBytes = await fetch(this.sampleCreditReportOrder).then(res => res.arrayBuffer());
    this.orderHandout = await PDFDocument.load(orderBytes);
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  async downloadOrder() {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.orderHandout.save();
    FileHelper.saveByteArray('sampleCreditReportOrder.pdf', pdfBytes, 'application/pdf');
  }
}
